import type { SmeCampaignInfo } from '@/types';
import { postSme } from '@/utils/request';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useSmeMerchantStore } from './sme-merchant';

export const useSmeCampaignStore = defineStore('sme-campaigns', () => {
  const campaigns = ref<SmeCampaignInfo[]>([]);
  const campaignsLoading = ref(true);
  const totalCampaignsFromSearch = ref<null | number>(null);
  const error = ref<any>(null);

  const smeMerchantStore = useSmeMerchantStore();

  // const companyOwner = smeMerchantStore.smeMerchant.companies.filter(
  //   (company: any) => company.company_role === 'ACCOUNT' && company.is_sme === true,
  // )[0];

  // const companyOwner = smeMerchantStore.smeMerchant.companies.filter((company: any) => company.company_role === 'COMPANY')[0];

  // const companyId = companyOwner.id;

  const getCampaigns = async (brandId: string) => {
    // const id = brandId ? brandId : companyId;

    try {
      const topProfileUrl = `/campaigns/search/companies/${brandId}?include_top_profiles=true`;
      const normalUrl = `/campaigns/search/companies/${brandId}`;
      campaignsLoading.value = true;
      const data = await postSme(topProfileUrl, {
        campaign_statuses: [],
        name: '',
        page_number: 1,
        page_size: 50,
        sortings: [
          {
            sort_by: 'STATUS',
            sort_direction: 'ASC',
          },
        ],
      });
      campaigns.value = data.search_results || [];
      totalCampaignsFromSearch.value = data.results_count;
    } catch (e) {
      error.value = e;
      throw e;
    } finally {
      campaignsLoading.value = false;
    }
  };

  const $reset = async () => {
    campaigns.value = [];
    campaignsLoading.value = false;
    totalCampaignsFromSearch.value = null;
    error.value = null;
  };

  return {
    campaigns,
    campaignsLoading,
    totalCampaignsFromSearch,
    getCampaigns,
    $reset,
  };
});
